AoPS.Utils.initKeyChain(AoPS, "Contests");

AoPS.Contests = (function (Contests) {
	Contests.Router = Backbone.Router.extend({
		initialize: function (options) {
			this.elements = {};
			this.models = {};
			this.models.master = options.master;
			this.myPage = new AoPS.Page.constructPage("contest");

			this.route(/(.*)/, this.routeHelperTrafficControl);
		},

		routeHelperTrafficControl: function (arg_string) {
			var processedUrl = AoPS.Contests.Utils.processUrl(arg_string);

			if (processedUrl.route === "landing") {
				this.routeHelperOuter(processedUrl);
			} else {
				// We should be on a different router.
				// Reloading will load it with a different router.
				window.location.reload(true);
			}
		},

		routeHelperOuter: function (processedUrl) {
			if (this.models.master.get("hasLoadedContentRegistration")) {
				this.routeHelperInner(processedUrl);
			} else {
				var contestString =
					processedUrl.routePreMatch === "putnam-supervisor"
						? "putnam"
						: processedUrl.routePreMatch;

				this.showLoading();

				this.models.master.loadContestRegistration(
					contestString,
					_.bind(function () {
						this.routeHelperInner(processedUrl);
					}, this),
					_.bind(this.showLoadError, this)
				);
			}
		},

		routeHelperInner: function (processedUrl) {
			var contestString =
				processedUrl.routePreMatch === "putnam-supervisor"
					? "putnam"
					: processedUrl.routePreMatch;

			if (contestString && contestString !== "main") {
				var contest = this.models.master
					.get("contests")
					.findWhere({contest_hash: contestString});
				if (contest && contest.get("has_landing_page")) {
					this.showContest(contest, processedUrl);
					return;
				} else if (contest && contest.get("registration_method") === "portal") {
					window.location.replace(
						"/contests/" + contest.get("contest_hash") + "/portal"
					);
					return;
				}
			}

			if (contestString.length) {
				window.location.replace("/contests");
				return;
			}

			this.showLanding();
		},

		showLanding: function () {
			this.myPage.clearPage({remove_modals: false});

			var elem = this.myPage.showElement({
				constructor: _.bind(function () {
					return new AoPS.Contests.Views.ContestLandingMain({
						model: this.models.master,
					});
				}, this),
			});

			this.myView = elem.view;
			document.title = "Contests";

			this.setBreadcrumbs();
			document.title = "AoPS Contests";
		},

		showContest: function (contest, processedUrl) {
			var elem;

			this.myPage.clearPage({remove_modals: false});
			this.myPage.$el.addClass(contest.get("contest_hash").replace("=", "-"));

			if (
				contest.get("registration_method") === "portal" &&
				processedUrl.routeMatch === "register"
			) {
				window.location.replace(
					"/contests/" + contest.get("contest_hash") + "/portal"
				);
				return;
			} else if (
				(contest.get("registration_method") === "register" &&
					processedUrl.routeMatch === "register") ||
				(contest.get("data") || {}).default_landing_route === "register"
			) {
				elem = this.myPage.showElement({
					constructor: _.bind(function () {
						return new AoPS.Contests.Views.ContestRegister({
							model: contest,
							args: processedUrl.routePostArgs,
						});
					}, this),
				});
				document.title = "Register for " + contest.get("contest_name");
			} else if (processedUrl.routeMatch === "details") {
				elem = this.myPage.showElement({
					constructor: _.bind(function () {
						return new AoPS.Contests.Views.ContestDetails({
							model: contest,
							args: processedUrl.routePostArgs,
						});
					}, this),
				});
				document.title = contest.get("contest_name") + " - Details";
			} else {
				elem = this.myPage.showElement({
					constructor: _.bind(function () {
						return new AoPS.Contests.Views.ContestLandingContest({
							model: contest,
							args: processedUrl.routePostArgs,
						});
					}, this),
				});
				document.title = contest.get("contest_name");
			}
			this.myView = elem.view;

			this.setBreadcrumbs();

			//move team div inside contest-practice-registration-form if the options indicate to do so
			//done this way to make it the last element inside
			if ((contest.get("data") || {}).move_team_inner) {
				$(
					".individual-inner .contest-landing-main .contest-practice-registration-form"
				).append($(".team-inner"));
			}
		},

		showLoading: function () {
			this.myPage.clearPage({remove_modals: false});

			var elem = this.myPage.showElement({
				constructor: _.bind(function () {
					return new AoPS.Contests.Views.ContestLandingLoading({
						model: this.models.master,
					});
				}, this),
			});
			this.myView = elem.view;

			this.setBreadcrumbs();
		},

		showLoadError: function () {
			this.myPage.clearPage({remove_modals: false});

			var elem = this.myPage.showElement({
				constructor: _.bind(function () {
					return new AoPS.Contests.Views.ContestLandingLoadError({
						model: this.models.master,
					});
				}, this),
			});
			this.myView = elem.view;

			this.setBreadcrumbs();
		},

		setBreadcrumbs: function () {
			var crumbs =
				(this.models.master.get("contests") || []).length > 1
					? [
							{
								text: "Contests",
								url: "/contests",
							},
					  ]
					: [];

			if (this.myView && _.isFunction(this.myView.constructCrumbs)) {
				crumbs = crumbs.concat(this.myView.constructCrumbs());
			} else {
				_.last(crumbs).url = null;
			}
			this.myPage.setBreadcrumbs(crumbs, "nav");
		},
	});

	/**
	 * Let's get started!
	 */
	$(window).on("load", function () {
		// Magical refresh
		AoPS.refreshOnBackButtonLoadWithOldData("contest");

		/**
		 * I usually start by building a master model that
		 *  is the air-traffic controller for everything.
		 */
		var contest_master = new AoPS.Contests.Models.Master(),
			my_router;

		/**
		 * Then we build the router.
		 */
		my_router = new Contests.Router({
			master: contest_master,
		});

		/**
		 * In the router, we construct the myPage object that
		 *  controls what we put on the page.  It has
		 *  a master view whose .el element is what we manage
		 *  to control what goes into the DOM.  Here, we add
		 *  that master element to the main-content window.
		 */
		$("#main-content").prepend(my_router.myPage.el);

		/**
		 * And then we press go.
		 */
		Backbone.history.start({pushState: true, root: ""});

		// Setting root to contest makes /contests#events be weird.

		$(document).on("click", "a[nav]", function (e) {
			var new_url = $(this).attr("href");
			if (!e.metaKey && !e.ctrlKey && new_url.indexOf("contests") > -1) {
				Backbone.history.navigate(
					new_url.replace(/^\/contests\/?/, "/contests/"),
					{
						trigger: true,
					}
				);
				e.stopPropagation();
				e.preventDefault();
			}
		});
	});

	return Contests;
})(AoPS.Contests);
